import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from '@ngxs/store';
import {LoginService} from '../service/login.service';
import {SesionState} from '@app/state/sesion/sesion.state';
import {ClearSesion} from '@app/state/sesion/sesion.actions';


@Injectable()
export class AuthGuardService  {

  constructor(public loginService: LoginService, public router: Router, private store: Store) {
  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.limpiarSesionInvalida();

    if (!this.loginService.getToken() && state.url !== '/login') {
      this.router.navigateByUrl('/login');
      return false;
    } else if (this.loginService.getToken() && state.url === '/login') {
      this.router.navigateByUrl('/');
      return false;
    }
    return true;
  }

  // Repara el estado persistido en localStorage de clientes que quedaron con un login sin user
  // (bug de SetAccessToken tras logout). Sin esto la sesión rota sobrevivía a cada recarga.
  private limpiarSesionInvalida(): void {
    const loginPersistido = this.store.selectSnapshot(SesionState.getLogin);
    if (loginPersistido && !this.loginService.getLogin()) {
      this.store.dispatch(new ClearSesion());
    }
  }

}
